<p-dialog [header]="userHeader" [modal]="true" [(visible)]="loadDialogView" [style]="{ width: '60rem' }"
    (onHide)="closeDialog(false)">
    <div class="user-details">
        <div>
            @if (userAttributeData?.tabs) {

            <app-mi-form [attributeLabels]="attributeLabels" [attributeValues]="attributeValues"
                [moduleName]="moduleName" [groups]="userAttributeData?.tabs[0].groups" (saveData)="onSaveUser($event)"
                [submitBtnText]="saveUserBtnLabel" [activeIndex]="activeIndex" [showCancelButton]="true"
                (onCancel)="closeDialog(false)"
                [saveBtnId]="prefixToAttachForButtonIdToUniquelyIdentifyButton + userAttributeData.tabs[0].tabCode"></app-mi-form>
            }
        </div>
    </div>
</p-dialog>